export const environment = {
  production: true,
  baseUrl: 'https://api-syntry-v1-dash.erpat.app'
};
